module.exports = __webpack_public_path__ + "img/virtualDesktop.b50e3cd.svg";